import type { PushType } from '@gooduncles/gu-app-schema';

export interface PushTypeOption {
  label: string;
  value: PushType;
  color: string;
}

export const pushTypeOptions: PushTypeOption[] = [
  { label: '공지', value: 'notice', color: 'blue' },
  { label: '프로모션', value: 'promotion', color: 'volcano' },
];

export function findPushTypeOption(type: PushType | string): PushTypeOption | undefined {
  return pushTypeOptions.find((o) => o.value === type);
}
